<template>
  <div id="hygrsh">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hygrsh'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/approve/person/Hygrsh.vue